(function () {
  angular.module('MktzapApp.Factories')
    .factory('MessageWebhookService', MessageWebhookService);

  MessageWebhookService.$inject = ['$resource'];

  function MessageWebhookService ($resource) {
    return $resource(apiUrl + '/channels-plugin/message-webhook/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: false }
    });
  }
})();
